import { render, staticRenderFns } from "./LsportDetail.vue?vue&type=template&id=ffdaf1d4&scoped=true"
import script from "./LsportDetail.vue?vue&type=script&lang=js"
export * from "./LsportDetail.vue?vue&type=script&lang=js"
import style0 from "./LsportDetail.vue?vue&type=style&index=0&id=ffdaf1d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdaf1d4",
  null
  
)

export default component.exports